import { createSelector } from '@reduxjs/toolkit'
import { createStructuredSelector } from 'reselect'

import { extractStencils } from '../utils/extracters'

const selectStencils = (state) => state.smtStencil?.stencils
const selectStencilsToBuy = (state) => state.smtStencil?.stencilsToBuy
const selectStencilsParameters = (state) => state.smtStencil?.stencilsParameters
const selectStencilsDestroy = (state) => state.smtStencil?.stencilsToDestroy

export const selectStencilsDataForCart = createSelector([
  selectStencilsToBuy,
  selectStencilsParameters,
  selectStencilsDestroy,
  ], (
    stencils,
    stencilsParameters,
    stencilsToDestroy,
  ) => {
    
    const items_to_destroy = stencilsToDestroy && stencilsToDestroy.length ? stencilsToDestroy : [];
    const data_for_forms = stencils && stencils.length ? {stencils, stencilsParameters} : {};
    
    return {
      stencilDataForForms: data_for_forms,
      stencilProps: extractStencils({stencils}),
      stencilsToDestroy: items_to_destroy,
    }
  }
);

export const selectStencilsForValidation = createStructuredSelector({
  stencils: selectStencils,
  stencilsParameters: selectStencilsParameters,
  stencilsToDestroy: selectStencilsDestroy,
});